<template>
<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="17.5" transform="rotate(-180 18 18)" stroke="currentColor"/>
<path d="M19.8232 10.1533C20.559 10.1623 21.293 10.2251 22.0195 10.3408V12.7158H20.7715C19.5635 12.716 19.1855 13.4611 19.1855 14.2236V16.0361H21.8926L21.4531 18.8252H19.1855V25.5713H16.1406V18.8252H13.6719V16.0361H16.1406V13.9102C16.1406 11.4916 17.5957 10.1533 19.8232 10.1533Z" fill="currentColor"/>
</svg>
</template>